import baseQuery from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

// Rule-set review/confirm seam (backend: views/rule_sets.py, Linear CHA-127).
// The CS-facing page never says "rule set" — it's the "Check a data file" flow.
export const ruleSetsApi = createApi({
    reducerPath: 'ruleSetsApi',
    baseQuery: baseQuery,
    tagTypes: ['RuleSets'],
    endpoints: (builder) => ({
        getRuleSets: builder.query({
            query: ({ clientName }) => `compass_portal/rule_sets/${clientName}`,
            providesTags: ['RuleSets'],
        }),
        previewRuleSet: builder.mutation({
            query: ({ clientName, ruleId, version, file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: `compass_portal/rule_sets/${clientName}/${ruleId}/${version}/preview`,
                    method: 'POST',
                    body: formData,
                };
            },
        }),
        confirmRuleSet: builder.mutation({
            query: ({ clientName, ruleId, version }) => ({
                url: `compass_portal/rule_sets/${clientName}/${ruleId}/${version}/confirm`,
                method: 'PUT',
            }),
            invalidatesTags: ['RuleSets'],
        }),
    }),
});

export const {
    useGetRuleSetsQuery,
    usePreviewRuleSetMutation,
    useConfirmRuleSetMutation,
} = ruleSetsApi;

export default ruleSetsApi.reducer;
